/** @jsxRuntime classic */
/** @jsx jsx */

import { FC, useEffect, useState } from 'react';
import { jsx } from '@emotion/react';

import { Draggable } from './Draggable';
import { ECalendarMode, IEventComponentProps } from '../../types';

import { ISlot } from '../../../organisms/bo_calendar_slot/types';
import { ResourceNameTypeEnum } from '../../../types/enums';
import { DRAGGABLE_ID_SEPARATOR, getCompoundDraggableId, getDraggableId } from '../../utils/consts';

interface IProps {
	slot: ISlot;
	parentId: string;
	EventComponent: FC<IEventComponentProps>;
	groupTop?: number;
	groupCount?: number;
	groupIndex?: number;
	currentDate: string;
	mode?: ECalendarMode;
	updateSlotData: (id: number, updatedSlot: Partial<ISlot>, data: any) => void;
}

export const DraggableSlot = ({
	slot,
	parentId,
	EventComponent,
	groupTop,
	groupCount,
	groupIndex,
	currentDate,
	mode,
	updateSlotData,
}: IProps) => {
	const isEditable = (slot as any).isDraft ? false : String(slot.resourceId) === String(parentId) || !slot.parentSlotId;

	// Extract resourceId from parentId (handles both "resourceId" and "resourceId_date" formats)
	const parentResourceId = parentId.split(DRAGGABLE_ID_SEPARATOR)[0];

	const draggableId =
		parentResourceId === String(slot.resourceId) && mode === ECalendarMode.DAILY
			? getDraggableId(slot.id, slot.resourceId)
			: getCompoundDraggableId(slot.id, slot.resourceId, currentDate);

	const [draggableSlot, setDraggableSlot] = useState(slot);

	useEffect(() => {
		setDraggableSlot(slot);
	}, [slot]);

	return (
		<Draggable
			parentId={parentId}
			state={draggableSlot}
			key={`${slot.id}-${parentId}`}
			id={draggableId}
			isEditable={isEditable}
			groupTop={groupTop}
			groupCount={groupCount}
			groupIndex={groupIndex}
			isConnectedMaintenance={!!slot?.parentSlotId || slot?.isConnectedMaintenance}
			currentDate={currentDate}
			setDraggableSlot={setDraggableSlot}
			updateSlotData={updateSlotData}
		>
			<EventComponent event={draggableSlot} currentDate={currentDate} mode={mode} />
		</Draggable>
	);
};
